import React from 'react'
import { Form } from 'react-bootstrap'
import { getIn } from 'formik'
import {
  isMobile,
  hideResponsiveButton,
  showResponsiveButton,
} from '../helpers'
import { useRef } from 'react'
import TooltipOnHover from './TooltipOnHover'
import { statusPresentation } from './FlightTrackingNew/flightFieldStatus'

const { Control, Group, Label } = Form

export default function FormField({
  field: { value = '', ...field } = {},
  form: { touched = {}, errors = {} } = {},
  icon,
  groupProps = {},
  handleChange,
  hintText,
  label,
  controlId,
  disabled = false,
  vehicleMismatch = false,
  groupClassName,
  changeRequest = false,
  useLabelAsPlaceholder = false,
  disableAutoComplete = false,
  showInfoIcon = false,
  showText,
  // RD-4073: flight-number status (standalone VIP search). Opt-in — every other FormField
  // renders exactly as before.
  flightStatus,
  flightStatusMessage,
  // RD-4073: opt-in clear ✕, the same control the Chauffeur flight field carries (design
  // asked for one component across both flows). Rendered only while there is something to
  // clear and the field is enabled.
  onClear,
  ...props
}) {
  const showError = !!getIn(touched, field.name) && !!getIn(errors, field.name)
  const statusView = showError
    ? null
    : statusPresentation(flightStatus, flightStatusMessage)
  const isMobileBrowser = isMobile()
  const fieldRef = useRef(null)
  const showClear =
    typeof onClear === 'function' &&
    !disabled &&
    value !== null &&
    value !== undefined &&
    String(value) !== ''
  const windowHeight = window.innerHeight
  var isFocused = false
  var isScrolled = false
  const onChange = e => {
    field.onChange(e)
    if (handleChange) {
      handleChange(e.target.value)
    }
  }

  const onFocus = () => {
    isScrolled = false
    isFocused = true
    hideResponsiveButton()
  }

  const onBlur = () => {
    isFocused = false
    showResponsiveButton()

    if (props.handleBlur && props.isRegisterEmail) {
      props.handleBlur()
    }

    if (props.handleBlur) {
      // console.log('inside props handleBlur')
      props.handleBlur()
    }
  }

  var timer = null

  if (isMobileBrowser) {
    if (timer) {
      clearInterval(timer)
    }
    timer = setInterval(() => {
      var allScrollables = document.getElementsByClassName(
        'scrollable-page-content'
      )

      var elScrollable = null

      if (allScrollables.length > 0) {
        elScrollable = allScrollables[allScrollables.length - 1]
      }

      if (!fieldRef || !fieldRef.current || !elScrollable) {
        clearInterval(timer)
        return
      }

      if (!isFocused) {
        return
      }

      if (windowHeight > window.innerHeight && !isScrolled) {
        setTimeout(() => {
          var bottom_gap =
            elScrollable.offsetHeight -
            fieldRef.current.getBoundingClientRect().bottom

          if (bottom_gap < 150) {
            const addScroll = 150 - bottom_gap
            elScrollable.scrollTop = elScrollable.scrollTop + addScroll
          }
        }, 200)
        isScrolled = true
      }
    }, 100)
  }

  const control = (
    <Control
      ref={fieldRef}
      {...field}
      value={
        changeRequest && typeof value === 'number'
          ? value > 0
            ? `+${value}`
            : `${value}`
          : value !== null && value !== undefined
          ? value
          : ''
      }
      {...props}
      isInvalid={showError}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      disabled={disabled}
      className={[
        props.inputClass || '',
        props.className || '',
        statusView
          ? `flight-status flight-status--${statusView.tone}${
              showClear ? '' : ' flight-status--no-clear'
            }`
          : '',
        showClear ? 'has-clear-button' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      autoComplete={disableAutoComplete ? 'off' : 'on'}
    />
  )

  return (
    <Group
      className={
        isMobileBrowser && field.name === 'promoCode'
          ? 'promoCode-mobile'
          : field.name === 'vehicleMismatch' && vehicleMismatch
          ? 'mb-0'
          : groupClassName || ''
      }
      style={
        field.name === 'name-cancellation-policy' && !isMobileBrowser
          ? {
              position: 'absolute',
              bottom: '0.5rem',
              left: '25px',
            }
          : field.name === 'cancelMeetGreetPolicy' && !isMobileBrowser
          ? { width: '10.8rem' }
          : {}
      }
      controlId={controlId || field.name}
    >
      {!!label && !useLabelAsPlaceholder && (
        // <Label className='form-label'>{label}</Label>
        <Label className='form-label'>
          {label}
          {showInfoIcon && (
            <TooltipOnHover
              delay={200}
              placement='right-start'
              // isMobileBrowser={isMobileBrowser}
              onMouseEnter={() => {}}
              component={<div>{showText}</div>}
            >
              <img
                className={'new-info-icon'}
                style={{
                  marginLeft: '0.5rem',
                  marginTop: '0.156rem',
                  height: '0.938rem',
                }}
                src='/images/icons/new-info-icon.png'
                alt=''
              />
            </TooltipOnHover>
          )}
        </Label>
      )}

      {typeof onClear === 'function' ? (
        <span className='form-field-clearable'>
          {control}
          {showClear && (
            <button
              type='button'
              className='form-field-clear'
              aria-label='Clear'
              onClick={() => {
                onClear()
                if (fieldRef.current) fieldRef.current.focus()
              }}
            >
              <img src='/images/icons/close-icon-black.png' alt='' />
            </button>
          )}
        </span>
      ) : (
        control
      )}
      {!!statusView && !!statusView.message && (
        <span
          className={`flight-status-message flight-status-message--${statusView.tone}`}
        >
          {statusView.message}
        </span>
      )}

      {/* <Control.Text> */}

      {/* </Control.Text> */}

      {!!hintText && (
        <Form.Text className='text-muted textarea-hint'>{hintText}</Form.Text>
      )}
      {!!showError && (
        <Control.Feedback type='invalid'>
          {getIn(errors, field.name)}
        </Control.Feedback>
      )}
    </Group>
  )
}
